var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyAsks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 76,
    fill: "none",
    viewBox: "0 0 103 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 101.682,
    height: 74.3,
    x: 0.703,
    y: 0.811,
    fill: "#fff",
    stroke: "#E2E6EF",
    rx: 4.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31.497,
    height: 29.367,
    x: 12.466,
    y: 19.701,
    fill: "#E2E6EF",
    rx: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 14.304,
    height: 6.161,
    x: 51.092,
    y: 20.228,
    fill: "#E2E6EF",
    rx: 3.08
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 39.53,
    height: 6.161,
    x: 51.092,
    y: 29.729,
    fill: "#E2E6EF",
    rx: 3.08
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 39.53,
    height: 6.161,
    x: 51.092,
    y: 39.518,
    fill: "#E2E6EF",
    rx: 3.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3291E9",
    d: "M51.0918 53.1405C51.0918 51.4392 52.471 50.0601 54.1723 50.0601H62.3154C64.0167 50.0601 65.3959 51.4392 65.3959 53.1405C65.3959 54.8418 64.0167 56.221 62.3154 56.221H54.1723C52.471 56.221 51.0918 54.8418 51.0918 53.1405Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3291E9",
    d: "M67.4014 53.1405C67.4014 51.7154 68.5567 50.5601 69.9818 50.5601H78.125C79.5501 50.5601 80.7054 51.7154 80.7054 53.1405C80.7054 54.5657 79.5501 55.721 78.125 55.721H69.9818C68.5567 55.721 67.4014 54.5657 67.4014 53.1405Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAsks);
export default __webpack_public_path__ + "static/media/empty-asks.3a97a4eea501b5dbc21ffe5684a9f4fa.svg";
export { ForwardRef as ReactComponent };